@if (customLoader?.show) {
    <div
        class="app-loading"
        [class.app-loading--with-resume]="customLoader.showResumePrompt"
        [class.app-loading--hide-text]="!!customLoader.hideTextKeepSpace"
    >
        <tec-spinner
            [ngClass]="{ dark: designService.isDarkMode() }"
            [show]="customLoader.show"
            [text]="customLoader.text"
            [opaque]="customLoader.opaque"
            [img]="resolveLoaderImage(customLoader.img)"
            [watermark]="(designService.configDesign$ | async)?.watermark"
        ></tec-spinner>
        <div class="app-loading__resume" [class.app-loading__resume--visible]="!!customLoader.showResumePrompt">
            <span class="app-loading__resume-question">{{ 'GENERAL.LOADING.STILL_THERE' | translate }}</span>
            <tec-link
                class="app-loading__resume-link"
                [size]="'sm'"
                [label]="'GENERAL.LOADING.TAP_TO_RESUME' | translate"
                (pointerdown)="onLoadingResumeClick()"
            ></tec-link>
        </div>
    </div>
}

@if (customLoadingIframe | async; as customLoaderIframe) {
    @if (customLoaderIframe.show) {
        <tec-spinner
            [ngClass]="{ 'pwcs-style-old': true, dark: designService.isDarkMode() }"
            [show]="customLoaderIframe.show"
            [text]="customLoaderIframe.text"
            [opaque]="customLoaderIframe.opaque"
            [watermark]="(designService.configDesign$ | async)?.watermark"
            [img]="resolveLoaderImage(customLoaderIframe.img)"
        ></tec-spinner>
    }
}

@if (snackbar | async; as snackBar) {
    <tec-snackbar [show]="snackBar?.show" [label]="snackBar?.text" (close)="snackbarService.hide()"></tec-snackbar>
}

@if (modalConfirmation | async; as confirmation) {
    <tec-modal
        type="confirmation"
        [isVisible]="confirmation?.show"
        [buttonSecondaryLabel]="confirmation?.buttonSecondaryLabel"
        [buttonPrimaryLabel]="confirmation?.buttonPrimaryLabel"
        [buttonPrimaryStyle]="confirmation?.buttonPrimaryStyle"
        (closeEvent)="dialogConfirmationService.setCloseDialogConfirmation($event)"
    >
        <ng-container body>
            <tec-tag-icon
                [size]="'default'"
                [icon]="confirmation.icon"
                [status]="confirmation.iconStatus"
            ></tec-tag-icon>
            <div class="body__text">
                <h4 [innerHTML]="confirmation?.title"></h4>
                <span [innerHTML]="confirmation?.description"></span>
            </div>
        </ng-container>
    </tec-modal>
}

<app-modal-change-language />

<router-outlet></router-outlet>
